export const get_plans = async () => {
  try {
    const token = localStorage.getItem('token');
    const url = `${process.env.REACT_APP_API_GCOM_URL}/plans`;
    const params = {
      method: 'GET',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}

export const post_plan = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const url = `${process.env.REACT_APP_API_GCOM_URL}/plans`;
    const params = {
      method: 'POST',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(data)
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}

export const delete_plan = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const id = data._id || data.id; // Support both legacy and modern ID property names
    const url = `${process.env.REACT_APP_API_GCOM_URL}/plans/${id}`;
    const params = {
      method: 'DELETE',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}

export const update_plan = async (data) => {
  try {
    const token = localStorage.getItem('token');
    const id = data._id || data.id;
    const url = `${process.env.REACT_APP_API_GCOM_URL}/plans/${id}`;
    const params = {
      method: 'PATCH',
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        'Accept': 'application/json',
        "Authorization": `Bearer ${token}`
      },
      body: JSON.stringify(data)
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;

  } catch (error) {
    console.log(error);
    return null;
  }
}
